<template>
    <container>
        <div class="ui segments raised">
            <CardTitle
                title="Faturas e Boletos"
                titleClass="ui violet large ribbon label"
            >
            </CardTitle>
            <ContainerBody>
                <ValidationObserver ref="frmBoletos" slim>
                      <div class="six wide column right aligned" style="height:25px;" >
                        <Button
                            title="Atualizar"
                            classIcon="icon refresh"
                            @click="filtrar"
                            position="right floated"
                            :disabled=false
                        />
                    </div>
                </ValidationObserver>
            </ContainerBody>
            <ContainerBody id="printArea" name="printArea">
                 <div class="ui grid" style="margin: 5px;">
                     &nbsp;
                 </div>
                 <div class="table-scroll">
                    <v-data-table
                        :headers="tableHeaders"
                        :items="dataItems"
                        item-key="recnum"
                        dense
                        class="ui table very compact celled selectable dataTable" style="width: 100%; white-space: nowrap;"
                        :footer-props="{
                            showFirstLastPage: true,
                        }"
                    >
                      <template v-slot:item="{ item }">
                        <tr>
                          <td class="center aligned">{{item.documento}}</td>
                          <td class="center aligned">{{formatarData(item.dataEmissao)}}</td>
                          <td class="center aligned">{{formatarData(item.dataVencimento)}}</td>
                          <td class="right aligned">{{ formatarValor(item.valorTitulo) }}</td>
                          <td class="right aligned">{{ formatarValor(item.valorPago) }}</td>
                          <td class="right aligned">{{ formatarValor(item.saldo) }}</td>
                          <template v-if="item.valorPago > 0 && item.saldo == 0">
                            <td class="center aligned">Liquidado</td>
                          </template>
                          <template v-else>
                            <td class="center aligned">
                              <a @click="abrirModalBoletoFatura(item,'boleto')" class="ui label violet button">Visualizar</a>
                            </td>
                          </template>
                          <template v-if="item.NFEPrefeitura && item.NFEPrefeitura.toString().trim().length > 0">
                            <td class="center aligned">
                              <a @click="abrirModalNFE(item.NFEPrefeitura,
                                                       item.municipio.replaceAll(' ',''),
                                                       item.cnpj.replaceAll('.', '').replaceAll('/', '').replaceAll('-', ''),
                                                       item.nfservRPS,
                                                       item.nfservSerie)"
                                 class="ui label blue button"
                              >
                                Visualizar
                              </a>
                             </td>
                          </template>
                          <template v-else>
                            <td class="center aligned">
                              <a class="ui label red button" >NF não emitida </a>
                            </td>
                          </template>
                          <td class="center aligned">
                             <a @click="abrirModalBoletoFatura(item,'fatura')" class="ui label red button">Visualizar</a>
                          </td>
                          <td class="center aligned">{{ item.tipoReceita }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                 </div>
            </ContainerBody>
        </div>
      <ModalPrint
        :title="titlePrint"
        :dialog="showPrint"
        :url="contentPrint"
        @close="showPrint = $event"
      />
      <ModalIframe
      :title="titleIframe"
      :dialog="showIframe"
      :url="contentIframe"
      @close="showIframe = $event"
    />
  </container>
</template>
<script>
import Container from '@/components/Container.vue';
import CardTitle from '@/components/CardTitle.vue';
import ContainerBody from '@/components/ContainerBody.vue';
import Button from '@/components/Button.vue';
import ModalPrint from '@/components/ModalPrint.vue';
import ModalIframe from '@/components/ModalIframe.vue';

import { ValidationObserver } from 'vee-validate';
import api from '@/services/api';
import axios from 'axios';
import config from '@/config';
import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales/pt-br';

const ambienteERP = sessionStorage.getItem('@ERP:ambienteERP');
const api_token = sessionStorage.getItem('@ERP:api_token');

export default {
  name: 'MonitorBoleto',
  components: {
    Container,
    CardTitle,
    ContainerBody,
    ValidationObserver,
    Button,
    ModalPrint,
    ModalIframe,
  },
  data() {
    return {
      tableHeaders: [
        { text: 'Nº Documento', align: 'end', value: 'documento' },
        { text: 'Emissão', align: 'end', value: 'dataEmissao' },
        { text: 'Vencimento', align: 'end', value: 'dataVencimento' },
        { text: 'Valor', align: 'end', value: 'valorTitulo' },
        { text: 'Valor Pago', align: 'end', value: 'valorPago' },
        { text: 'Saldo', align: 'end', value: 'saldo' },
        { text: 'Boleto', align: 'end', value: 'talonario' },
        { text: 'NF Serviço', align: 'end', value: 'notaFiscalServico' },
        { text: 'Fatura', align: 'end', value: 'codigoFatura' },
        { text: 'Produto', align: 'end', value: 'tipoReceita' },
      ],
      dataItems: [],
      titlePrint: '',
      showPrint: false,
      contentPrint: '',
      titleIframe: '',
      showIframe: false,
      contentIframe: '',
    };
  },
  watch: {
    showPrint() {
      if (!this.showPrint) {
        this.contentPrint = '';
      }
    },
  },
  mounted() {
    numeral.locale('pt-br');
    this.filtrar();
  },
  methods: {
    async filtrar() {
      this.$store.commit('global/loading');
      await api.get('/api/reports/Financeiro/monitor-boletos-og')
        .then((result) => {
          this.dataItems = result.data.dados;
        });
      this.$store.commit('global/loaded');
    },
    siglaAmbienteERP(ambiente) {
      let sigla = 'api';
      if (ambiente == 'appbkp') {
        sigla = 'sandbox';
      }
      if (ambiente == 'develop') {
        sigla = 'develop-api';
      }
      return sigla;
    },
    abrirModalBoletoFatura(dados, tipoDocumento) {
      const siglaAmbiente = this.siglaAmbienteERP(ambienteERP);
      this.titlePrint = `Impressão de ${tipoDocumento}`;
      this.contentPrint = `https://${siglaAmbiente}.otimogestor.com.br/api/reports/Financeiro/visualiza-fatura-boleto-og/${dados.recnum}/${tipoDocumento}?api_token=${api_token}`;
      this.showPrint = true;
    },
    abrirModalNFE(notafiscal, cidade, cnpj, rps, serie) {
      this.$store.commit('global/loading');
      axios.get(`${config.apiUrl}/api/DFE/DownloadNFSE?cnpj=${cnpj}&cidade=${cidade}&notafiscal=${notafiscal}&rps=${rps}&serie=${serie}&api_token=${api_token}`)
        .then((response) => {
          this.$store.commit('global/loaded');
          this.titleIframe = `Nota Fiscal de Serviço Nº ${notafiscal}`;
          this.showIframe = true;
          this.contentIframe = response.data;
        });
    },
    formatarValor(valor) {
      return numeral(valor).format('0,0.00');
    },
    formatarData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
  },
};
</script>
